import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import routes from 'utils/routes';
import { STORAGE_AUTH_DATA } from 'constants/localStorage';
import { logger } from '../utils/logger';

class ApiClient {
  private static instance: ApiClient;
  private api: AxiosInstance;

  private constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    this.api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
      }

      const authDataStr = localStorage.getItem(STORAGE_AUTH_DATA);
      if (authDataStr) {
        try {
          const authData = JSON.parse(authDataStr);
          if (authData?.access_token) {
            config.headers['Authorization'] = `Bearer ${authData.access_token}`;
          }
        } catch (error) {
          // Deferred logging won't interfere with auth flow
          logger.authError('Failed to parse auth data from localStorage', error as Error, {
            component: 'apiInterceptor'
          });
        }
      }

      return config;
    });

    this.api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem(STORAGE_AUTH_DATA);
          // Fix: Use window.location.href instead of useNavigate() hook
          // Hooks cannot be used inside Axios interceptors
          window.location.href = routes.signInPath.href;
        }
        return Promise.reject(error);
      }
    );
  }

  public static getInstance(): AxiosInstance {
    if (!ApiClient.instance) {
      ApiClient.instance = new ApiClient();
    }
    return ApiClient.instance.api;
  }
}

const api = ApiClient.getInstance();
export default api;
